import React, { useContext, useRef, useState } from 'react'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import InputFieldV2 from '../../../lib/input/InputFieldV2'
import { apiConstants } from '../../../utils/apiConstants'
import { REQUIRED_VALIDATION } from '../../../lib/input/validation-rules'
import { emptyFunction, getCompanyName } from '../../../utils'
import { MyContext } from '../../../context'
import { makePostCall } from '../../../effects/requests'
import { endPoints } from '../../../utils/endpoints'
import { ApiResponseType } from '../../../types'
import SuccessCreate from '../../../global/ui/SuccessCreate'

const CreateCollections = ({ onClose, onDone }: any) => {

    const { userData } = useContext(MyContext);

    const { ...methods } = useForm({
        mode: 'all',
        defaultValues: { [apiConstants.name]: '' },
        reValidateMode: 'onBlur',
    });

    const [selectedMedia, setSelectedMedia] = useState<any>(null)
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const fileInputRef = useRef<HTMLInputElement>(null);

    const onSubmit: SubmitHandler<any> = (data: any) => {
        const fd = new FormData();
        fd.append('name', data?.name);
        fd.append('production_company_name', getCompanyName(userData));
        if (selectedMedia?.file) {
            fd.append('thumbnail', selectedMedia?.file);
        }
        makePostCall(endPoints.LOCATION_COLLECTION, fd).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                setShowSuccessModal(true);
            }
        }).catch(emptyFunction)
    };

    const handleFiles = (files: FileList | null) => {
        if (!files) return;
        setSelectedMedia({ file: files?.[0], image: URL.createObjectURL(files?.[0]) })
    };

    return (
        <div>
            {/* Backdrop */}
            <div className="cl-backdrop" />

            {/* Drawer panel */}
            <div className="cl-drawer">

                {/* Header */}
                <div className="cl-drawer__header">
                    <button className="cl-drawer__close" onClick={onClose}>
                        <img src='/assets/images/dismiss.svg' alt='close' />
                    </button>
                    <h2 className="cl-drawer__title">Create Collection</h2>
                </div>

                {/* Step content */}
                <div className="cl-drawer__body">
                    <FormProvider {...methods}>
                        <div className="cl-step">
                            <h3 className="cl-step__heading">Assign collection cover image</h3>
                            {/* Upload tile */}
                            <button
                                style={{ height: '110px' }}
                                className="cl-photo-upload-tile"
                                onClick={() => fileInputRef.current?.click()}
                            >
                                {selectedMedia?.image
                                    ?
                                    <img height={110} src={selectedMedia?.image} alt={`photo-collection`} />
                                    :
                                    <>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6b5ce7" strokeWidth="2">
                                            <polyline points="16 16 12 12 8 16" /><line x1="12" y1="12" x2="12" y2="21" />
                                            <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                                        </svg>
                                        <span>Upload</span>
                                    </>
                                }

                            </button>
                            <input
                                ref={fileInputRef}
                                type="file"
                                accept="image/*"
                                hidden
                                onChange={(e) => handleFiles(e.target.files)}
                            />
                            <div className="cl-step__fields">
                                <InputFieldV2
                                    name={apiConstants.name}
                                    label="Collection name"
                                    type="text"
                                    placeholder="Enter collection name"
                                    rules={REQUIRED_VALIDATION('Collection name')}
                                    maxLength={150}
                                />

                            </div>
                        </div>
                    </FormProvider>
                </div>

                {/* Footer: action button */}
                <div className="cl-drawer__footer">
                    <div />
                    <button
                        type='button'
                        className="cl-btn-next"
                        onClick={methods.handleSubmit(onSubmit)}
                    >
                        Create
                    </button>
                </div>
            </div>

            {showSuccessModal &&
                <SuccessCreate
                    decription='Collection successfully created.'
                    heading='Collection Created'
                    onClose={() => {
                        setShowSuccessModal(false);
                        onDone?.()
                    }}
                />
            }
        </div>
    )
}

export default CreateCollections